import "./LandingPage.css";
import "../globals/global.css"

import "../../../components/transitions.css"
import { CSSTransition } from 'react-transition-group';
import { useState } from "react";

import NavigationBar from "./../../../components/navbar/NavigationBar";
import PageTitle from '../../../components/Page Title/PageTitle'
import { useNavigate } from "react-router-dom";

const LandingPage = () => {
  const navigate = useNavigate();

  const [inProp, setInProp] = useState(true);

  const links = [
  {
    label: "DISCORD",
    url: "https://discord.gg/heroesandgeneralsbeta",
    className: "discord",
  },
  {
    label: "PATREON",
    url: "https://www.patreon.com/hnggroup",
    className: "patreon",
  },
  {
    label: "REDDIT",
    url: "https://www.reddit.com/r/HeroesandGenerals/",
    className: "reddit",
  },
];

  const handleClick = () => {
    setInProp(false); // Trigger animation
    setTimeout(() => navigate("/play", { state: { fromLanding: true } }), 500); // Navigate after animation
  };
  return (
    <div>
      <NavigationBar/>
      <CSSTransition
      in={inProp}
      timeout={500}
      classNames="slide-out-left"
      unmountOnExit
      >
        <div>
          <PageTitle title="Heroes And Generals: Sunrise" />
          <div className="pagebox text-center">
            <div>
              <div class="section-title">
                Heroes and generals is back!
              </div>
              <span class="section-text">
                 Welcome to an established community project that aims to revive and continues the game's legacy. Giving players a chance to play the game we all knew and loved, once more.
              </span>
            </div>
            <button class="btn btn-major" onClick={handleClick}>PLAY!</button>
            <div className="link-buttons">
              {links.map((link) => (
                <a
                  key={link.label}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`link-button ${link.className}`}
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>
        </div>
      </CSSTransition>
    </div>
  );
};
export default LandingPage;